import {
  COMMON_SHOW_NOTIFICATION,
  ORDER_CANCEL_ORDER,
  ORDER_CANCEL_STOP_ORDER,
  ACCOUNT_OTP_VERIFY_SUCCESS,
  GET_SIGN_TOKENCA,
} from 'redux/actions';
import { IAction, INotification } from 'interfaces/common';
import { ICancelOrderReducer } from 'interfaces/reducers';
import {
  ICancelStopOrderMultiParams,
  ICancelStopOrderResponse,
  IEquityCancelOrderParams,
  IEquityCancelOrderResponse,
  ISignTokenCAResponse,
  ISaveSignTokenCAResponse,
} from 'interfaces/api';
import { OrderKind } from 'constants/enum';
import { ToastType } from 'react-toastify';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { query } from 'utils/socketApi';
import config from 'config';
import { enquiryPortfolio } from 'components/common/OrderForm/actions';
import { IState } from 'redux/global-reducers';
import { signTokenCA, registerTokenCA } from '../../../../utils/signTokenCA';
import { addHours } from 'date-fns';

function cancelOrder(params: IEquityCancelOrderParams) {
  return query(config.apis.equityCancelOrder, params);
}

function cancelStopOrder(params: ICancelStopOrderMultiParams) {
  return query(config.apis.cancelStopOrderMulti, params);
}

function* doCancelOrder(request: IAction<IEquityCancelOrderParams>) {
  const store: IState = yield select((state: IState) => ({
    signTokenCA: state.signTokenCA,
    otp: state.otp,
  }));

  try {
    if (store.signTokenCA?.isTokenCA) {
      const data = {
        action: 'verifyTokenCancelOrder',
        serialToken: store.signTokenCA?.serial,
        dataSign: {
          subAccount: request.payload.accountNo,
          orders: request.payload.orders
        },
        timeSign: new Date(),
      };

      if (store.signTokenCA?.serial) {
        const responseSign: ISignTokenCAResponse = yield call(signTokenCA, store.signTokenCA?.serial, data);
        if (responseSign && responseSign.code == 1) {
          let dataSubmit = {
            dataSignTokenCA: responseSign.data,
            ...data,
          };

          const responseSaveSignTokenCA: ISaveSignTokenCAResponse = yield call(registerTokenCA, {
            action: 'verifyTokenCancelOrder',
            serialToken: store.signTokenCA.serial ?? '',
            dataSign: JSON.stringify(dataSubmit),
            timeSign: addHours(new Date(), 7).toISOString() ?? '',
          });

          if (
            responseSaveSignTokenCA &&
            responseSaveSignTokenCA.status !== 201
          ) {
            yield put<IAction<INotification>>({
              type: COMMON_SHOW_NOTIFICATION,
              payload: {
                type: ToastType.ERROR,
                title: 'Cancel Order',
                content: 'CANCEL_ORDERS_FAILED',
                time: new Date(),
              },
            });
          } else {
            const response: {
              data?: IEquityCancelOrderResponse[];
            } = yield call(cancelOrder, request.payload);

            if (response?.data != null && request.response != null) {
              const successOrders = response.data.filter((val) => val.success);
              const failedOrders = response.data.filter((val) => !val.success);
              yield put<IAction<ICancelOrderReducer>>({
                type: request.response.success,
                payload: {
                  orderKind: OrderKind.NORMAL_ORDER,
                  result: response.data,
                },
              });
              if (successOrders.length > 0) {
                yield put(
                  enquiryPortfolio({ accountNumber: request.payload.accountNo })
                );
                if (successOrders.length === 1) {
                  yield put<IAction<INotification>>({
                    type: COMMON_SHOW_NOTIFICATION,
                    payload: {
                      type: ToastType.SUCCESS,
                      title: 'Cancel Order',
                      content: 'CANCEL_ORDER_SUCCESS',
                      contentParams: { orderNumber: successOrders[0].orderNo },
                      time: new Date(),
                    },
                  });
                } else {
                  yield put<IAction<INotification>>({
                    type: COMMON_SHOW_NOTIFICATION,
                    payload: {
                      type: ToastType.SUCCESS,
                      title: 'Cancel Order',
                      content: 'CANCEL_ORDERS_SUCCESS',
                      time: new Date(),
                    },
                  });
                }
              }

              if (failedOrders.length > 0) {
                if (failedOrders.length === 1) {
                  yield put<IAction<INotification>>({
                    type: COMMON_SHOW_NOTIFICATION,
                    payload: {
                      type: ToastType.ERROR,
                      title: 'Cancel Order',
                      content: failedOrders[0].rejectCause,
                      time: new Date(),
                    },
                  });
                } else {
                  yield put<IAction<INotification>>({
                    type: COMMON_SHOW_NOTIFICATION,
                    payload: {
                      type: ToastType.ERROR,
                      title: 'Cancel Order',
                      content: 'CANCEL_ORDERS_FAILED',
                      time: new Date(),
                    },
                  });
                }
              }
            }
          }
        }
      }
    } else {
      const response: { data?: IEquityCancelOrderResponse[] } = yield call(
        cancelOrder,
        request.payload
      );

      if (response?.data != null && request.response != null) {
        const successOrders = response.data.filter((val) => val.success);
        const failedOrders = response.data.filter((val) => !val.success);
        yield put<IAction<ICancelOrderReducer>>({
          type: request.response.success,
          payload: {
            orderKind: OrderKind.NORMAL_ORDER,
            result: response.data,
          },
        });
        if (successOrders.length > 0) {
          yield put(
            enquiryPortfolio({ accountNumber: request.payload.accountNo })
          );
          if (successOrders.length === 1) {
            yield put<IAction<INotification>>({
              type: COMMON_SHOW_NOTIFICATION,
              payload: {
                type: ToastType.SUCCESS,
                title: 'Cancel Order',
                content: 'CANCEL_ORDER_SUCCESS',
                contentParams: { orderNumber: successOrders[0].orderNo },
                time: new Date(),
              },
            });
          } else {
            yield put<IAction<INotification>>({
              type: COMMON_SHOW_NOTIFICATION,
              payload: {
                type: ToastType.SUCCESS,
                title: 'Cancel Order',
                content: 'CANCEL_ORDERS_SUCCESS',
                time: new Date(),
              },
            });
          }
        }

        if (failedOrders.length > 0) {
          if (failedOrders.length === 1) {
            yield put<IAction<INotification>>({
              type: COMMON_SHOW_NOTIFICATION,
              payload: {
                type: ToastType.ERROR,
                title: 'Cancel Order',
                content: failedOrders[0].rejectCause,
                time: new Date(),
              },
            });
          } else {
            yield put<IAction<INotification>>({
              type: COMMON_SHOW_NOTIFICATION,
              payload: {
                type: ToastType.ERROR,
                title: 'Cancel Order',
                content: 'CANCEL_ORDERS_FAILED',
                time: new Date(),
              },
            });
          }
        }
      }
    }
  } catch (error) {
    console.error('Cancel order error', error);
    if (request.response) {
      yield put<IAction<string>>({
        type: request.response.failed,
        payload: error.code || error.message,
      });
    }

    yield put<IAction<INotification>>({
      type: COMMON_SHOW_NOTIFICATION,
      payload: {
        type: ToastType.ERROR,
        title: 'Cancel Order',
        content: error.code || error.message,
        contentParams: error.messageParams,
        time: new Date(),
      },
    });
  }

  if (store.otp?.otpToken?.data?.expiryTime == 0) {
    yield put({
      type: ACCOUNT_OTP_VERIFY_SUCCESS,
      payload: {
        token: null,
      },
    });
  }

  yield put({
    type: GET_SIGN_TOKENCA,
    payload: {
      serial: '',
      isTokenCA: false,
    },
  });
}

function* doCancelStopOrder(request: IAction<ICancelStopOrderMultiParams>) {
  const store: IState = yield select((state: IState) => ({
    signTokenCA: state.signTokenCA,
    otp: state.otp,
  }));

  try {
    if (store.signTokenCA?.isTokenCA) {
      const data = {
        action: 'verifyTokenStopCancelOrder',
        serialToken: store.signTokenCA?.serial,
        dataSign: {
          idListStopCancelOrder: request.payload
        },
        timeSign: new Date(),
      };

      if (store.signTokenCA?.serial) {
        const responseSign: ISignTokenCAResponse = yield call(
          signTokenCA,
          store.signTokenCA?.serial,
          data
        );
        if (responseSign && responseSign.code == 1) {
          let dataSubmit = {
            dataSignTokenCA: responseSign.data,
            ...data,
          };

          const responseSaveSignTokenCA: ISaveSignTokenCAResponse = yield call(registerTokenCA, {
            action: 'verifyTokenStopCancelOrder',
            serialToken: store.signTokenCA.serial ?? '',
            dataSign: JSON.stringify(dataSubmit),
            timeSign: addHours(new Date(), 7).toISOString() ?? '',
          });

          if (
            responseSaveSignTokenCA &&
            responseSaveSignTokenCA.status !== 201
          ) {
            yield put<IAction<INotification>>({
              type: COMMON_SHOW_NOTIFICATION,
              payload: {
                type: ToastType.ERROR,
                title: 'Cancel Stop Order',
                content: 'CANCEL_STOP_ORDERS_FAILED',
                time: new Date(),
              },
            });
          } else {
            const response: {
              data?: ICancelStopOrderResponse;
            } = yield call(cancelStopOrder, request.payload);
        
            if (response?.data != null && request.response != null) {
              yield put<IAction<ICancelOrderReducer>>({
                type: request.response.success,
                payload: {
                  orderKind: OrderKind.STOP_LIMIT_ORDER,
                  result: [response.data],
                },
              });
        
              yield put<IAction<INotification>>({
                type: COMMON_SHOW_NOTIFICATION,
                payload: {
                  type: ToastType.SUCCESS,
                  title: 'Cancel Order',
                  content: 'CANCEL_ORDER_SUCCESS',
                  time: new Date(),
                },
              });
            }
          }
        }
      }
    } else {
      const response: {
        data?: ICancelStopOrderResponse;
      } = yield call(cancelStopOrder, request.payload);
  
      if (response?.data != null && request.response != null) {
        yield put<IAction<ICancelOrderReducer>>({
          type: request.response.success,
          payload: {
            orderKind: OrderKind.STOP_LIMIT_ORDER,
            result: [response.data],
          },
        });
  
        yield put<IAction<INotification>>({
          type: COMMON_SHOW_NOTIFICATION,
          payload: {
            type: ToastType.SUCCESS,
            title: 'Cancel Order',
            content: 'CANCEL_ORDER_SUCCESS',
            time: new Date(),
          },
        });
      }
    }
  } catch (error) {
    console.error('Cancel order error', error);
    if (request.response) {
      yield put<IAction<string>>({
        type: request.response.failed,
        payload: error.code || error.message,
      });
    }

    yield put<IAction<INotification>>({
      type: COMMON_SHOW_NOTIFICATION,
      payload: {
        type: ToastType.ERROR,
        title: 'Cancel Order',
        content: error.code || error.message,
        contentParams: error.messageParams,
        time: new Date(),
      },
    });
  }

  if (store.otp?.otpToken?.data?.expiryTime == 0) {
    yield put({
      type: ACCOUNT_OTP_VERIFY_SUCCESS,
      payload: {
        token: null,
      },
    });
  }

  yield put({
    type: GET_SIGN_TOKENCA,
    payload: {
      serial: '',
      isTokenCA: false,
    },
  });
}

export default function* watchCancelOrder() {
  yield takeLatest(ORDER_CANCEL_ORDER, doCancelOrder);
  yield takeLatest(ORDER_CANCEL_STOP_ORDER, doCancelStopOrder);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/Order/Equity/CancelOrder.ts